import React from 'react';
import { canadianCities } from '../../data/locations';
import { industries } from '../../data/industries';

export default function DirectTestPage() {
  const toronto = canadianCities.find(c => c.slug === 'toronto');
  const medical = industries.find(i => i.slug === 'medical-professionals');
  
  return (
    <div style={{ padding: '40px' }}>
      <h1>Direct Import Test</h1>
      
      <h2>Data Check:</h2>
      <ul>
        <li>Cities loaded: {canadianCities.length}</li>
        <li>Industries loaded: {industries.length}</li>
        <li>Toronto data: {toronto ? '✓' : '✗'}</li>
        <li>Medical data: {medical ? '✓' : '✗'}</li>
      </ul>
      
      <h2>Component Import Test:</h2>
      <p>Now testing direct component imports...</p>
      
      {toronto && (
        <div style={{ border: '1px solid #ccc', padding: '20px', margin: '20px 0' }}>
          <h3>Toronto Data:</h3>
          <pre>{JSON.stringify(toronto, null, 2).slice(0, 500)}...</pre>
        </div>
      )}
    </div>
  );
}